export function calculateMargin(costPrice, sellingPrice) {
  if (!sellingPrice || sellingPrice <= 0) return 0;
  const profit = sellingPrice - costPrice;
  return Number(((profit / sellingPrice) * 100).toFixed(2));
}

export function calculateLandedCost(subtotal, freight = 0, packaging = 0, handling = 0) {
  return Number(subtotal) + Number(freight) + Number(packaging) + Number(handling);
}

export function calculateDaysToExpiry(expiryDateStr) {
  if (!expiryDateStr) return 999;
  const target = new Date(expiryDateStr);
  const now = new Date("2026-08-08T00:00:00");
  const diffTime = target.getTime() - now.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
}

export function getExpiryBadgeInfo(days) {
  if (days <= 0) {
    return { status: "Expired", color: "red", text: `Expired ${Math.abs(days)}d ago` };
  } else if (days <= 30) {
    return { status: "Critical Expiry", color: "amber", text: `${days}d left` };
  } else if (days <= 90) {
    return { status: "Expiring Soon", color: "amber", text: `${days}d left` };
  }
  return { status: "Fresh", color: "emerald", text: `${days}d left` };
}

export function calculateWarehouseOccupancy(warehouse) {
  if (!warehouse || !warehouse.sections) return { totalCapacity: 0, currentCount: 0, percentage: 0 };
  let totalCapacity = 0;
  let currentCount = 0;

  warehouse.sections.forEach((sec) => {
    sec.racks.forEach((rack) => {
      rack.shelves.forEach((shelf) => {
        shelf.bins.forEach((bin) => {
          totalCapacity += bin.maxCapacity || 0;
          currentCount += bin.currentCount || 0;
        });
      });
    });
  });

  const percentage = totalCapacity > 0 ? Math.round((currentCount / totalCapacity) * 100) : 0;
  return { totalCapacity, currentCount, percentage };
}

export function calculateTotalStock(productId, batches) {
  return batches
    .filter((b) => b.productId === productId && b.status !== "Expired")
    .reduce((sum, b) => sum + (Number(b.qtyRemaining) || 0), 0);
}
